// Rails constants
export const MAX_NUMBER_OF_PAGES = 350
export const LETTER_BOOK_TITLE_LIMIT = 50

// Other

export const MIN_NUMBER_OF_PAGES = 20
// Min number of pages for a book created by 2nd payment invoice
export const MIN_BOX_BOOK_NUMBER_OF_PAGES = 25
